export const IconFilterSliders: {
  name: 'icon_filter_sliders-22f6177883c3'
} = {
  name: 'icon_filter_sliders-22f6177883c3'
}
